"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIntersectionObserver = require("react-intersection-observer");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var LazyImage = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var thumbnail = props.thumbnail,
    thumbnailSrc = props.thumbnailSrc,
    _a = props.withPlaceholder,
    withPlaceholder = _a === void 0 ? true : _a,
    _b = props.observerOptions,
    observerOptions = _b === void 0 ? {} : _b,
    _c = props.loadingEffect,
    loadingEffect = _c === void 0 ? 'blur' : _c,
    _d = props.transitionDuration,
    transitionDuration = _d === void 0 ? 1 : _d,
    onLoad = props.onLoad,
    width = props.width,
    height = props.height,
    filteredProps = __rest(props, ["thumbnail", "thumbnailSrc", "withPlaceholder", "observerOptions", "loadingEffect", "transitionDuration", "onLoad", "width", "height"]);
  var _e = (0, _reactIntersectionObserver.useInView)(__assign({
      triggerOnce: true,
      rootMargin: '100px 0px'
    }, observerOptions)),
    inViewRef = _e[0],
    isInView = _e[1];
  var _f = (0, _react.useState)(false),
    isLoaded = _f[0],
    setIsLoaded = _f[1];
  var _g = (0, _react.useState)(true),
    renderPlaceHolder = _g[0],
    setRenderPlaceHolder = _g[1];
  var handleOnLoad = (0, _react.useCallback)(function (event) {
    setIsLoaded(true);
    if (typeof onLoad === 'function') {
      onLoad(event);
    }
  }, [onLoad]);
  var handleOnTransitionEnd = (0, _react.useCallback)(function () {
    setRenderPlaceHolder(false);
  }, []);
  return (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
    style: {
      width: width,
      height: height
    },
    ref: inViewRef
  }, {
    children: isInView ? (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [withPlaceholder && renderPlaceHolder ? thumbnail && /*#__PURE__*/(0, _react.isValidElement)(thumbnail) ? thumbnail : thumbnailSrc ? (0, _jsxRuntime.jsx)(Styled.Thumbnail, __assign({}, filteredProps, {
        "$isLoaded": isLoaded,
        "$loadingEffect": loadingEffect,
        "$transitionDuration": transitionDuration,
        ref: ref,
        src: thumbnailSrc
      })) : (0, _jsxRuntime.jsx)(Styled.Placeholder, {
        "$isLoaded": isLoaded,
        "$loadingEffect": loadingEffect,
        "$transitionDuration": transitionDuration
      }) : null, (0, _jsxRuntime.jsx)(Styled.Image, __assign({}, filteredProps, {
        "$isLoaded": isLoaded,
        "$transitionDuration": transitionDuration,
        ref: ref,
        onLoad: handleOnLoad,
        onTransitionEnd: handleOnTransitionEnd
      }))]
    }) : null
  }));
});
LazyImage.displayName = 'LazyImage';
var _default = LazyImage;
exports.default = _default;